<template>
  <div class="fair-survey-step fair-survey-step--thank-you">
    <div class="fair-survey-step__head fair-survey-step__head--centered">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <FairButton
      class="fair-survey-step__cta"
      label="Посмотреть результаты"
      variant="primary"
      size="m"
      :rounded="false"
      :disabled="surveyStore.surveyModal.isLoading"
      @click="viewResults"
    />

    <p
      v-if="surveyStore.surveyModal.isLoading"
      class="fair-survey-step__note"
    >
      Анализируем ваши параметры…
    </p>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { FairButton } from '@/ui/primitives/FairButton'
import { useSurveyModal } from '@/features/survey/store'
import type { SurveyStep } from '@/features/survey/types/survey-config'

defineProps<{ step: SurveyStep & { type: 'thank_you' } }>()
const surveyStore = useSurveyModal()
const router = useRouter()

async function viewResults() {
  try {
    // Отправляем данные на бекенд
    await surveyStore.submitSurvey()
    
    // Закрываем модальное окно
    surveyStore.hideSurveyModal()
    
    // Редиректим на страницу результатов
    router.push('/profile/sizes')
  } catch (error) {
    console.error('Error submitting survey:', error)
    // В случае ошибки все равно закрываем модалку и редиректим
    surveyStore.hideSurveyModal()
    router.push('/profile/sizes')
  }
}
</script>

<style scoped>
.fair-survey-step--thank-you {
  justify-content: center;
  align-items: center;
  text-align: center;
}

.fair-survey-step__cta {
  align-self: center;
}
</style>
